var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row cards-list carousel-card-list test"},_vm._l((_vm.coursesList),function(item){return _c('course-card',{key:item.id,attrs:{"course":item,"corporation":_vm.corporation,"forSlider":true},on:{"enroll":_vm.doEnroll,"wait-list":_vm.doWaitList}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }